var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"loginOverlay ma-auto",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"flex":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md3":""}},[_c('LoginForm',{attrs:{"portalName":_vm.$t('customer.portal.title'),"loginFunction":_vm.loginFunc}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }